/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/prefer-default-export */
import { AxiosRequestConfig } from 'axios';
import isBrowser from '@/helpers/isBrowser';
import getSessionId from '@/helpers/getSessionId';

type AxiosInterceptor = {
  onFulfilled: (config: AxiosRequestConfig<any>) => AxiosRequestConfig<any>;
  onRejected?: (error: any) => any;
};

const addSessionIdToHeader: AxiosInterceptor = {
  onFulfilled: (config): AxiosRequestConfig => {
    if (isBrowser()) {
      if (!config.headers) {
        // eslint-disable-next-line no-param-reassign
        config.headers = {};
      }

      // eslint-disable-next-line no-param-reassign
      config.headers['x-sessionId'] = getSessionId();
    }
    return config;
  },
};

const interceptors = { addSessionIdToHeader };

export default interceptors;
